import { notification } from 'antd'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import { customAxios as axios, getToken } from '../../../request'
import {
  getIssueWebPageUrl,
  updateIssueWebPageUrl,
  updateSpecialIssueWebPageDrawerUrl,
  deleteSpecialIssueItemUrl
} from '../apis/issueWebPage'


export const getIssueWebPageFxn = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(getIssueWebPageUrl(), valData, getToken())
  dispatch(hidePageLoad())
  return data
}

export const updateJournalWebPage = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(
    updateIssueWebPageUrl(),
    valData,
    getToken()
  )
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    notification.success({
      message: data.message || 'Success'
    })
  }
  dispatch(hidePageLoad())
  return data
}


export const updateSpecialIssueWebPageDrawerFxn = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(updateSpecialIssueWebPageDrawerUrl(), valData, getToken())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    notification.success({
      message: data.message || 'Success'
    })
  }
  dispatch(hidePageLoad())
  return data
}


export const deleteSpecialIssueItemFxn = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(deleteSpecialIssueItemUrl(), valData, getToken())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    notification.success({
      message: data.message || 'Success'
    })
  }
  dispatch(hidePageLoad())
  return data
}
